"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CallToAction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="170734" id="call-to-action" className="bg-background relative w-full pt-16 md:pt-24">
      <div className="relative bg-primary text-primary-foreground">
        {}
        <div className="absolute top-0 inset-x-0 -translate-y-[99%] text-primary overflow-hidden leading-none pointer-events-none">
          <svg viewBox="0 0 1440 100" fill="currentColor" preserveAspectRatio="none" className="w-full h-12 md:h-24" aria-hidden="true">
            <polygon points="0,100 720,0 1440,100" />
          </svg>
        </div>

        <div className="container mx-auto px-6 py-20 md:py-32 relative z-10">
          <div ref={ref} className={`max-w-4xl mx-auto text-center flex flex-col items-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-7xl font-bold text-primary-foreground mb-6 leading-tight tracking-tight">
              Ready to Start Your Recovery?
            </h2>
            
            <p className="text-lg md:text-xl lg:text-2xl text-primary-foreground/90 mb-12 max-w-2xl font-light tracking-wide leading-relaxed">
              Experience the premium standard of chiropractic care in Cyprus. Our dedicated team is ready to help you rediscover a life of movement and vitality.
            </p>
            
            <Link to="/ContactPage">
              <Button variant="secondary" size="lg" className="h-14 px-10 text-base md:text-lg uppercase tracking-wider font-semibold group rounded-full bg-accent text-accent-foreground shadow-lg hover:shadow-[0_0_25px_rgba(255,255,255,0.3)] hover:scale-105 transition-all duration-300">
                Book Your Appointment
                <ArrowRight className="ml-3 w-5 h-5 transition-transform duration-300 group-hover:translate-x-2" />
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>;
}